import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import Filter from '../Filter'
import CameraDetails from '../CameraDetails'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FixedSizeList as List } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import sortBy from 'ramda/src/sortBy'
import isEmpty from 'ramda/src/isEmpty'

const NoMatch = ({ classes, selectedManufacturer, filterCameras }) =>
  <div className={classes.NoMatch}>
    { selectedManufacturer ? `No matching ${selectedManufacturer} cameras!` : 'No matching cameras!' }
    { selectedManufacturer &&
      <div onClick={_ => filterCameras(null, '', null, true)} className={classes.resetButton}>
        <FontAwesomeIcon icon={['far', 'times-circle']} className={classes.resetIcon} />
        Clear search
      </div>
    }
  </div>


const CameraListItem = ({ data, index, style }) => {
  const { cameras, classes, initialCamera, updateCameraList, favoriteModels, recentModels } = data
  const camera = cameras[index]

  return (
    <div
      onClick={_ => updateCameraList(camera)}
      className={initialCamera && camera.model === initialCamera.model ? classes.selected : (index % 2 === 0 ? classes.listItemEven : classes.listItemOdd)}
      style={style}
    >
      <span className={classes.modelName}>{camera.model}</span>
      {
        recentModels.includes(camera.id) &&
        <FontAwesomeIcon icon={'history'} className={classes.clock} />
      }
      { favoriteModels.includes(camera.id) &&
        <FontAwesomeIcon icon='star' className={classes.star} />
      }
    </div>
  )
}

const cameraData = ({ cameras, classes, initialCamera, updateCameraList, favoriteModels, recentModels }) => ({
  cameras: sortBy(c => recentModels.includes(c.id) ? (favoriteModels.includes(c.id) ? 0 : 1) : (favoriteModels.includes(c.id) ? 2 : 3))(cameras),
  initialCamera,
  classes,
  updateCameraList,
  favoriteModels,
  recentModels
})

const CameraList = props => {
  const { cameras, classes } = props

  return (
    <div className={classes.cameraList}>
      {
        isEmpty(cameras)
        ? <div className={classes.list}>
            <NoMatch {...props} />
          </div>
        : <AutoSizer disableWidth>
            {({ height }) => (
              <List
                height={height}
                itemCount={cameras.length}
                itemData={cameraData(props)}
                itemSize={36}
                width={'100%'}
                className={classes.list}
              >
                { CameraListItem }
              </List>
            )}
          </AutoSizer>
      }
    </div>
  )
}

const ListItem = ({ data, index, style }) => {
  const { manufacturers, initialManufacturer, filterCameras, search, classes } = data
  const manufacturer = manufacturers[index]

  return (
    <div
      onClick={_ => filterCameras(null, search, manufacturer)}
      className={initialManufacturer === manufacturer ? classes.selected : (index % 2 === 0 ? classes.listItemOdd : classes.listItemEven)}
      style={style}
    >
      {manufacturer}
    </div>
  )
}

const manufacturerData = ({ manufacturers, initialManufacturer, filterCameras, search, classes }) => ({
  manufacturers,
  initialManufacturer,
  filterCameras,
  search,
  classes
})

class ManufacturerList extends React.Component {
  renderList = _ => {
    const { selectedCamera, selectedManufacturer, initialCamera, initialAoV, manufacturers, filterCameras, updateCameraList,
      search, close, classes } = this.props

    if (selectedCamera) return <CameraDetails { ...{ selectedCamera, initialCamera, initialAoV, updateCameraList, close } } />

    if (selectedManufacturer) {
      return (
        <div className={classes.body}>
          <div className={classes.header}>
            <div className={classes.backLink} onClick={_ => filterCameras(null, search, null, true)}>
              <FontAwesomeIcon icon='chevron-left' className={classes.backButton} />
              Brands
            </div>
            <div className={classes.title}>
              { selectedManufacturer }
            </div>
            <div style={{ flex: 1 }} />
          </div>
          <CameraList {...this.props} />
        </div>
      )
    }

    return (
      <div className={classes.body}>
        {
          isEmpty(manufacturers)
          ? <div className={classes.list}>
              <NoMatch {...this.props} />
            </div>
          : <AutoSizer disableWidth>
              {({ height }) => (
                <List
                  height={height}
                  itemCount={manufacturers.length}
                  itemData={manufacturerData(this.props)}
                  itemSize={36}
                  width={'100%'}
                  className={classes.list}
                >
                  { ListItem }
                </List>
              )}
            </AutoSizer>
          }
      </div>
    )
  }

  render() {
    const { renderList, props: { selectedCamera, selectedManufacturer, filterCameras, search, formFactors, classes } } = this

    return (
      <div className={classes.container}>
        { !selectedCamera && <Filter { ...{ selectedManufacturer, filterCameras, search, formFactors } } /> }
        { renderList() }
      </div>
    )
  }
}

export default (injectSheet(style)(ManufacturerList))



// WEBPACK FOOTER //
// ./src/components/BottomBar/ModelSelector/ManufacturerList/index.js